import React, { useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import SearchLocation from './SearchLocation';
import styles from './SearchLocationCtrl.module.scss';

/**
 * SearchControlCtrl component.
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.map - The OpenLayers Map instance.
 */
export default function SearchControlCtrl({ map }) {
  const [isOpen, setIsOpen] = useState(false);

  /**
   * Toggles the visibility of the SearchLocation component.
   */
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Paper elevation={4} sx={{ p: '2px' }}>
        <IconButton color="primary" aria-label="search-localisation" title="Rechercher localisation" onClick={toggle}>
          <SearchIcon />
        </IconButton>
      </Paper>
      <Fade in={isOpen}>
        <Paper elevation={4} className={styles.content} sx={{ width: 320 }}>
          <SearchLocation map={map} />
        </Paper>
      </Fade>
    </>
  );
}

SearchControlCtrl.propTypes = {
  map: PropTypes.object.isRequired,
};
